import { apiGet, apiPut } from '../helpers/ApiHelper';
import Auth from 'j-toker';
import { updateLanguage } from 'react-localize-redux';
import * as documentPortalActions from './documentPortalActions';

export function getDocument(userType, signer_id, document_id, document_type) {
  return dispatch => {
    let url;
    if (userType === 'lead') {
      url = `/document_signing/signers/${signer_id}/lead_internal_documents/${document_id}?document_type=${document_type}`;
    } else if (userType === 'landlord') {
      url = `/document_signing/signers/${signer_id}/landlord_internal_documents/${document_id}?document_type=${document_type}`;
    }

    return apiGet(Auth.getApiUrl() + url)
      .done(response => {
        if (response.data.document.language_code) {
          dispatch(updateLanguage(response.data.document.language_code));
          localStorage.setItem('locale', response.data.document.language_code);
        }
        dispatch(documentPortalActions.displayDocument(response.data));
      })
      .catch(error => {
        dispatch(documentPortalActions.signError(error.responseJSON.error));
      });
  };
}

export function putDocument(userType, data) {
  let url;
  if (userType === 'lead') {
    url = `/document_signing/signers/${data.signer_uuid}/lead_internal_documents/${data.document_uuid}?document_type=${data.document_type}`;
  } else if (userType === 'landlord') {
    url = `/document_signing/signers/${data.signer_uuid}/landlord_internal_documents/${data.document_uuid}?document_type=${data.document_type}`;
  }

  return dispatch => {
    return apiPut(Auth.getApiUrl() + url, data)
      .done(response => {
        dispatch(documentPortalActions.showSendingLoader(false));
        dispatch(documentPortalActions.hideDocument());
        dispatch(documentPortalActions.enableSignButton(false));
        dispatch(documentPortalActions.signSuccess());
      })
      .catch(error => {
        window.Rollbar.error('Internal Document Portal Signing Error', error);
        dispatch(documentPortalActions.signError(error.responseJSON.error));
        dispatch(documentPortalActions.showSendingLoader(false));
      });
  };
}
